import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { ExclamationTriangleFill } from "react-bootstrap-icons";

const ConfirmRegistrationModal = ({ show, handleClose, handleConfirm }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirmClick = async () => {
    setLoading(true);
    await handleConfirm(); // هنا بيتم تنفيذ الفنكشن اللي فيها الـ API أو التسجيل
    setTimeout(() => {
      setLoading(false);
      handleClose();
    }, 1500);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="w-100 text-center">
          <ExclamationTriangleFill color="#0d6efd" size={35} className="mb-2" />
          <div>Confirm Registration</div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        <p className="text-muted mb-3">
          Are you sure you want to register for this activity? <br />
          <span className="fw-semibold text-primary">Note:</span>{" "}
          Missing it may reduce your participation score.
        </p>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center border-0">
        <Button
          variant="primary"
          onClick={handleConfirmClick}
          disabled={loading}
          className="d-flex align-items-center gap-2"
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" /> Registering...
            </>
          ) : (
            "Confirm"
          )}
        </Button>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmRegistrationModal;
